import { orderBy } from "firebase/firestore";
import { useEffect } from "react";
import { Alert, Button, Card } from "react-bootstrap";
import { FaPlus } from "react-icons/fa";
import { MdPower, MdPowerOff } from "react-icons/md";
import { Link, useNavigate, useParams } from "react-router";

import { useDockCollection } from "../../api/firestoreWrappers.generated.jsx";
import { Breadcrumbs, breadcrumbPaths } from "../../components/Breadcrumbs";
import {
    CorvusList,
    CorvusListItem,
    CorvusListItemText,
} from "../../components/CorvusList";
import Layout, { Title } from "../../components/Layout/Layout";
import urls from "../../urls.jsx";

export default function DockListPage() {
    const { organizationId, locationId } = useParams();
    const navigate = useNavigate();
    const [docks] = useDockCollection(organizationId, locationId, [
        orderBy("name", "asc"),
    ]);

    useEffect(() => {
        if (!locationId || locationId === "undefined") {
            navigate(urls.locations(organizationId), { replace: true });
        }
    }, [locationId, organizationId, navigate]);

    return (
        <Layout>
            <title>Docks | MyCorvus</title>
            <Breadcrumbs path={breadcrumbPaths.dockList} />
            <Card>
                <Title
                    title={"Docks"}
                    backButtonUrl={urls.location(organizationId, locationId)}
                >
                    <div>
                        <Button
                            className="d-inline ms-2 ms-2"
                            variant="outline-success"
                            as={Link}
                            to={urls.dockCreate(organizationId, locationId)}
                        >
                            <FaPlus className="me-2" />
                            New Dock
                        </Button>
                    </div>
                </Title>
                {docks.length === 0 && (
                    // TODO : Move this functionalty to a component and reuse it in DroneListPage & RoutineListPage
                    <Alert variant="primary" className="mx-4 mb-4">
                        No docks
                    </Alert>
                )}
                {docks.length > 0 && (
                    <CorvusList>
                        {docks.map((dock) => (
                            <CorvusListItem
                                className="p-0"
                                key={dock.id}
                                as={Link}
                                to={urls.dock(
                                    organizationId,
                                    locationId,
                                    dock.id,
                                )}
                            >
                                <CorvusListItemText>
                                    <span className="me-1">
                                        {dock?.name && dock.name !== ""
                                            ? dock.name
                                            : dock.id}
                                    </span>
                                    {dock.powered !== undefined && (
                                        <span className="me-1">
                                            {dock.powered ? (
                                                <MdPower className="text-success" />
                                            ) : (
                                                <MdPowerOff className="text-secondary" />
                                            )}
                                        </span>
                                    )}
                                    <code className="ms-1">
                                        {`x: ${dock.position.x}, y: ${dock.position.y}, z: ${dock.position.z}, yaw: ${dock.yaw}`}
                                    </code>
                                    {dock.takeoffHeight !== undefined && (
                                        <code>
                                            , takeoff height:{" "}
                                            {dock.takeoffHeight}m
                                        </code>
                                    )}
                                    {dock.calibrationPointOffset !==
                                        undefined && (
                                        <code className="ms-1">
                                            {`, cal. offset: (${dock.calibrationPointOffset.x}, ${dock.calibrationPointOffset.y}, ${dock.calibrationPointOffset.z})`}
                                        </code>
                                    )}
                                    {dock.returnPointOffset !== undefined && (
                                        <code className="ms-1">
                                            {`, ret. offset: (${dock.returnPointOffset.x}, ${dock.returnPointOffset.y}, ${dock.returnPointOffset.z})`}
                                        </code>
                                    )}
                                </CorvusListItemText>
                            </CorvusListItem>
                        ))}
                    </CorvusList>
                )}
            </Card>
        </Layout>
    );
}
